<label for="formControlName">{{ labelT | translate }}</label>
<quill-editor [formControlName]="formControlName" />
